import { createBackendApi } from "@/lib/backendApi";
import { localApi } from "@/lib/localApi";

function isNetworkLikeError(error) {
  const msg = String(error?.message || "");
  return (
    msg.includes("Failed to fetch") ||
    msg.includes("NetworkError") ||
    msg.includes("Load failed")
  );
}

export async function detectApiClient() {
  const backend = createBackendApi();
  try {
    await backend.health();
    return backend;
  } catch (error) {
    if (!isNetworkLikeError(error)) {
      // If backend exists but health returns an app error, still prefer backend.
      if (error?.response?.status && error.response.status < 500) {
        return backend;
      }
    }
    return localApi;
  }
}

